import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-67">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-68">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl" data-id="element-69"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-600/5 rounded-full blur-3xl" data-id="element-70"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-teal-500/5 rounded-full" data-id="element-71"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-teal-500/5 rounded-full" data-id="element-72"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32" data-id="element-73">
        <div className="text-center" data-id="element-74">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-75">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-display font-bold text-white mb-6 leading-tight" data-id="element-76">
              Tu identidad digital.
              <br data-id="element-77" />
              <span className="text-teal-500" data-id="element-78">Segura. Privada. Tuya.</span>
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg sm:text-xl text-gray-400 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-79">
            Verifica tu identidad una vez. Úsala en todas partes. truid te
            permite controlar tus datos personales mientras accedes de forma
            segura a servicios financieros, salud, gobierno y más.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-80">
            <button className="group bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-all flex items-center space-x-2 shadow-lg shadow-teal-500/20 hover:shadow-teal-500/30" data-id="element-81">
              <span data-id="element-82">Descubre cómo funciona</span>
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-83" />
            </button>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-16 flex flex-wrap items-center justify-center gap-8 text-sm text-gray-500" data-id="element-84">
            <div className="flex items-center space-x-2" data-id="element-85">
              <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-86"></div>
              <span data-id="element-87">Certificado ISO 27001</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-88">
              <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-89"></div>
              <span data-id="element-90">Cumplimiento GDPR</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-91">
              <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-92"></div>
              <span data-id="element-93">Compatible eIDAS</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}